import { useEffect } from 'react';
import { ExpandableTableProviderProps, RowData } from './types';
import {
  applyMeta,
  collectExpandedIdsFromDataSource,
  expandTree,
  useExpandFolder,
} from './utils';

const ExpandableTableProvider = <TData extends RowData>(
  props: ExpandableTableProviderProps<TData>
) => {
  const [expandedFoldersIds, expandFolder, setExpandedFoldersIds] =
    useExpandFolder(props.expandedFoldersIds, props.setExpandedFoldersIds);

  const rawDataSource = applyMeta(props.dataSource, props.idIndex);
  const dataSource = expandTree(
    rawDataSource,
    expandedFoldersIds,
    [],
    props.idIndex
  );

  useEffect(() => {
    if (!props.skipExpandOnSearch) {
      setExpandedFoldersIds(
        collectExpandedIdsFromDataSource(
          rawDataSource,
          props.searchPhrase ?? ''
        )
      );
    }
    // disable eslint complaining about dataSource missing,
    // this is not needed, since datasource doesn't change while modal is open
    // eslint-disable-next-line
  }, [props.searchPhrase]);

  return props.render({ dataSource, expandFolder, expandedFoldersIds });
};

export { ExpandableTableProvider };
